import React from 'react';
import { Box, Card, CardContent, Typography, Button, Grid, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Subscription = () => {
  const plans = [
    {
      name: 'Free',
      price: '$0',
      period: 'month',
      features: ['Basic features', 'Limited storage', 'Community support'],
      current: true
    },
    {
      name: 'Pro',
      price: '$9.99',
      period: 'month',
      features: ['All Free features', 'Unlimited storage', 'Priority support', 'Advanced analytics'],
      current: false
    },
    {
      name: 'Enterprise',
      price: '$29.99',
      period: 'month',
      features: ['All Pro features', 'Custom integrations', 'Dedicated support', 'Team management'],
      current: false
    }
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom>
        Current Plan
      </Typography>
      <Grid container spacing={3}>
        {plans.map((plan) => (
          <Grid item xs={12} md={4} key={plan.name}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                border: plan.current ? '2px solid' : '1px solid',
                borderColor: plan.current ? 'primary.main' : 'divider'
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h5" component="h2" gutterBottom>
                  {plan.name}
                </Typography>
                <Typography variant="h4" component="div" gutterBottom>
                  {plan.price}
                  <Typography component="span" variant="body2" color="text.secondary">
                    /{plan.period}
                  </Typography>
                </Typography>
                <List>
                  {plan.features.map((feature, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <CheckCircleIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText primary={feature} />
                    </ListItem>
                  ))}
                </List>
                <Button
                  variant={plan.current ? "outlined" : "contained"}
                  fullWidth
                  sx={{ mt: 2 }}
                  disabled={plan.current}
                >
                  {plan.current ? 'Current Plan' : 'Upgrade'}
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Subscription; 